export function getAdminSearchDetailUrl(
    text: string,
    useAnalogs: boolean,
    client?: string
): string {
    return `/search-details?text=${text}&useAnalogs=${useAnalogs}${
        client ? `&client=${client}` : ''
    }`;
}
